export default "__VITE_ASSET__GJY5ujWW__"